import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';
import { CompetitionTab } from './competition-tab';

export class CompetitionTabView extends Backbone.View {
  initialize(options) {
    this.options = options;
  }

  render() {
    ReactDOM.render(
      (
        <CompetitionTab {...this.options} />
      ), this.el
    );
    return this;
  }

  remove() {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}
